export const OVERVIEW_CARD_HEIGHT = '300px'
